import { createSlice } from "@reduxjs/toolkit";

import { addDelivery, updateDelivery } from "./deliveryActions";

const initialState = {
  addLoading: false,
  updateLoading: false,
};

const deliverySlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addDelivery.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addDelivery.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(addDelivery.rejected, (state) => {
        state.addLoading = false;
      })
      .addCase(updateDelivery.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updateDelivery.fulfilled, (state) => {
        state.updateLoading = false;
      })
      .addCase(updateDelivery.rejected, (state) => {
        state.updateLoading = false;
      });
  },
});

export default deliverySlice.reducer;
